import { MutationFunction, UseMutationOptions } from '@tanstack/react-query';
import { ResponsesAccountReportFormData } from '@/shared/api/orval/models';
import { BodyType, ErrorType, axiosForReactQueryDocServiceInstance } from '@/shared/api/reactQuery';

export interface ReportAccountsMonthlyResponse {
  data: { docBase64: string };
}

export const postDocApiReportAccountsMonthly = (payload: ResponsesAccountReportFormData) =>
  axiosForReactQueryDocServiceInstance<ReportAccountsMonthlyResponse>({
    url: `/api/report/accounts/monthly`,
    method: 'POST',
    data: payload,
    params: { extension: 'html' }
  });

export type PostDocApiReportAccountsMonthlyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDocApiReportAccountsMonthly>>
>;

export type PostDocApiReportAccountsMonthlyMutationBody = BodyType<ResponsesAccountReportFormData>;

export const getPostDocApiReportAccountsMonthlyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    PostDocApiReportAccountsMonthlyMutationResult,
    TError,
    {
      payload: PostDocApiReportAccountsMonthlyMutationBody;
    },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    PostDocApiReportAccountsMonthlyMutationResult,
    {
      payload: ResponsesAccountReportFormData;
    }
  > = (props) => {
    const { payload } = props;
    return postDocApiReportAccountsMonthly(payload);
  };

  return { mutationFn, ...mutationOptions };
};
